import { render, staticRenderFns } from "./ContractsOverview.vue?vue&type=template&id=56b484b3"
import script from "./ContractsOverview.vue?vue&type=script&lang=js"
export * from "./ContractsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports